import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getBaseUrl(): string {
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.NEXT_PUBLIC_SITE_URL &&
    process.env.NEXT_PUBLIC_SITE_URL !== ''
  ) {
    return process.env.NEXT_PUBLIC_SITE_URL;
  }
  return 'http://localhost:3000/';
}
